<template>
    <div class="push-scheme-container">
        <el-tabs v-model="activeName">
            <el-tab-pane label="按用户细分定位" name="user">
                <div class="device-flex">
                    <div>
                        选择细分维度： <span class="title-description">（用户细分定位可排重推送）</span>
                    </div>
                    <div class="device-number" v-if="detailData.last_send_number">{{detailData.last_send_number}}<span>个目标设备</span></div>
                </div>
                
                <div class="check-group-buttons">
                    <span class="button" :class="{'active': item.checked}" v-for="item in groupOptions" :key="item.label" @click="handlerDimension(item)"> 
                        {{ item.label }} 
                    </span>
                </div>
                <el-form :model="pushDeviceFilterForm" label-width="230px" class="margin-top-18" ref="form" >
                    <template>
                        <div v-for="(item,index) in userPositionFormItems" :key="'form-item'+index">
                            <el-form-item class="border-form-item" v-if="item.checked" :label="item.label" :prop="item.key" 
                                :rules="{
                                    required: item.checked, message: ' ', trigger: ['blur', 'change']
                                }"> 
                                <span class="line"></span>
                                <div class="flex" v-if="['reg_date', 'last_login_date'].includes(item.key)">
                                    <el-input-number placeholder="无限制" 
                                        size="small"
                                        :disabled="isDetail"
                                        v-model="pushDeviceFilterForm[item.key][0]" 
                                        :min="0"
                                        :controls='false' :precision="0"></el-input-number>
                                    <span>-</span>
                                    <el-input-number placeholder="无限制" 
                                        size="small"
                                        :disabled="isDetail"
                                        v-model="pushDeviceFilterForm[item.key][1]" 
                                        :min="pushDeviceFilterForm[item.key][0]"
                                        :controls='false' :precision="0"></el-input-number>
                                    <span>天</span>     
                                </div>
                                <div class="flex slider" v-else-if="['future_7days_lose', 'future_7days_pay'].includes(item.key)">
                                    <el-slider
                                        :disabled="isDetail"
                                        v-model="pushDeviceFilterForm[item.key]"
                                        range
                                        :marks="marks"
                                        class="w450">
                                    </el-slider>
                                </div>
                                
                                <el-select v-model="pushDeviceFilterForm[item.key]" 
                                    v-else
                                    :disabled="isDetail"
                                    :placeholder="'请选择'+item.label" 
                                    filterable
                                    size="small" class="w450" 
                                    remote
                                    :remote-method="(kwd) => filterData(kwd,item)"
                                    :multiple="item.key !== 'os'" >
                                    <el-option v-for="row in item.options" :label="row.label" :value="row.value" :key="'label'+row.label+row.value"></el-option>
                                </el-select>
                                <el-button type="danger" size="small" icon="el-icon-delete" circle v-if="!isDetail && item.label !== 'OS'" @click="handlerDimension(item,index)"></el-button>
                            </el-form-item>
                        </div>
                    </template>
                </el-form>
            </el-tab-pane>
        </el-tabs>
        <el-button class="next-button margin-top-18" type="primary" size="small" @click="handlerNext" v-if="!isDetail">下一步</el-button>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
const groupsButtonText = ['OS', '包名', 'SDK版本', '语言', '国家', '游戏版本', '注册时间（天）', '最后登录时间（天）'];
export default {
    name: 'devive-filter',
    data() {
        return {
            activeName:'user',
            pushDeviceFilterForm: {
                os: ''
            },
            groupOptions: this.initGroupOptions(),
            platformConfig: {},
            marks:{
                0: '0%',
                25: '25%',
                50: '50%',
                75: '75%',
                100: '100%',
            },
            userPositionFormItems: [{
                label: 'OS',
                key: 'os',
                options: [{
                    label: 'Android',
                    value: 'android'
                }, {
                    label: 'IOS',
                    value: 'ios'
                }],
                checked: false
            }, {
                label: '包名',
                key: 'package_id',
                options: [],
                checked: false
            }, {
                label: 'SDK版本',
                key: 'sdk_version_id',
                options: [],
                checked: false
            }, {
                label: '语言',
                key: 'lang',
                options: [],
                checked: false
            }, {
                label: '国家',
                key: 'country',
                options: [],
                checked: false
            }, {
                label: '游戏版本',
                key: 'game_version_id',
                options: [],
                checked: false
            }, {
                label: '注册时间（天）',
                key: 'reg_date',
                options: [{
                    label: 'com1',
                    value: 'com1'
                }, {
                    label: 'com77',
                    value: 'com77'
                }],
                checked: false
            }, {
                label: '最后登录时间（天）',
                key: 'last_login_date',
                options: [{
                    label: 'com88',
                    value: 'com88'
                }, {
                    label: 'com99',
                    value: 'com99'
                }],
                checked: false
            }]
        };
    },
    computed: {
        ...mapState('pushPushPlanOperate', ['data', 'detailData']),
        ...mapState(['$activeGameInfo', '$lodash']),
    },
    props: ['isDetail', 'isCopy'],
    methods: {
        ...mapActions('pushPushPlanOperate', ['getPlatformConfig', 'getCountry']),
        initGroupOptions() {
            let options = [];
            groupsButtonText.forEach(name => {
                options.push({
                    checked: false,
                    label: name
                });
            });
            return options;
        },
        handlerNext() {
            this.$refs['form'].validate(valid => {
                if (valid) {
                    for (let key in this.pushDeviceFilterForm) {
                        if (key !== 'os') {
                            console.log(this.pushDeviceFilterForm);
                            if (['reg_date', 'last_login_date'].includes(key) &&  typeof this.pushDeviceFilterForm[key][1] === 'number') {
                                if (typeof this.pushDeviceFilterForm[key][0] === 'number' && this.pushDeviceFilterForm[key][1] < this.pushDeviceFilterForm[key][0]) {
                                    this.$alert('保存失败，时间维度最大值必须大于最小值！');
                                    return;
                                }
                            }
                        }
                    }
                    this.$emit('submit', this.pushDeviceFilterForm, 1);
                }
            });
        },
        handlerDimension(row, index) {
            if (this.isDetail || row.label === 'OS') return; 
            if (typeof index === 'number') {
                this.groupOptions[index].checked = !row.checked;
            }
            row.checked = !row.checked;
            this.userPositionFormItems.forEach(item => {
                if (item.label === row.label) {
                    item.checked = row.checked;
                    if (row.checked) {
                        const initVal = ['future_7days_lose', 'future_7days_pay'].includes(item.key) ? [75, 100] : [];
                        this.$set(this.pushDeviceFilterForm, item.key, initVal);
                    }
                    else {
                        delete this.pushDeviceFilterForm[item.key];
                    }
                    setTimeout(() => {
                        this.$refs['form'].clearValidate(item.key);
                    }, 0);
                }
            });
        },
        filterCountry(kwd, row) {
            let options = [];
            if (typeof kwd === 'string' && kwd) {
                options = this.platformConfig.country_list.filter(item => {
                    let names = [item.code2, item.code3, item.continent, item.name, item.name_cn].join('【】').toLowerCase();
                    return names.toLowerCase().indexOf(kwd) > -1;
                });
            }
            else {
                options = _.cloneDeep(this.platformConfig.country_list);
            }
            row.options = options.map(list => {
                return {
                    label: list.name_cn,
                    value: list.name
                };
            });
        },
        filterPackage(kwd, row) {
            let options = [];
            if (typeof kwd === 'string' && kwd) {
                options = this.platformConfig.package_list.filter(item => {
                    let names = [item.package_name, item.package_id].join('【】').toLowerCase();
                    return names.toLowerCase().indexOf(kwd) > -1;
                });
            }
            else {
                options = _.cloneDeep(this.platformConfig.package_list);
            }
            row.options = options.map(list => {
                return {
                    label: list.package_name,
                    value: list.package_id
                };
            });
        },
        filterSDKVersion(kwd, row) {
            let options = [];
            if (typeof kwd === 'string' && kwd) {
                options = this.platformConfig.sdkversion_list.filter(item => {
                    let names = [item.sdk_version, item.sdk_version_id].join('【】').toLowerCase();
                    return names.toLowerCase().indexOf(kwd) > -1;
                });
            }
            else {
                options = _.cloneDeep(this.platformConfig.sdkversion_list);
            }
            row.options = options.map(list => {
                return {
                    label: list.sdk_version,
                    value: list.sdk_version_id
                };
            });
        },
        filterGameVersion(kwd, row) {
            let options = [];
            if (typeof kwd === 'string' && kwd) {
                options = this.platformConfig.gameversion_list.filter(item => {
                    let names = [item.game_version_id, item.game_version].join('【】').toLowerCase();
                    return names.toLowerCase().indexOf(kwd) > -1;
                });
            }
            else {
                options = _.cloneDeep(this.platformConfig.gameversion_list);
            }
            row.options = options.map(list => {
                return {
                    label: list.game_version,
                    value: list.game_version_id
                };
            });
        },
        filterLang(kwd, row) {
            let options = [];
            if (typeof kwd === 'string' && kwd) {
                options = this.$activeGameInfo.lang.filter(item => {
                    let names = [item.local_name, item.full_code, item.name, item.full_code.toUpperCase()].join('【】').toLowerCase();
                    return names.toLowerCase().indexOf(kwd) > -1;
                });
            }
            else {
                options = _.cloneDeep(this.$activeGameInfo.lang);
            }
            row.options = options.map(list => {
                return {
                    label: list.name,
                    value: list.full_code
                };
            });
        },
        filterData(kwd, row) {
            switch (row.key) {
                case 'country':
                    this.filterCountry(kwd, row);
                    break;
                case 'package_id':
                    this.filterPackage(kwd, row);
                    break;
                case 'game_version_id':
                    this.filterGameVersion(kwd, row);
                    break;
                case 'sdk_version_id':
                    this.filterSDKVersion(kwd, row);
                    break;
                case 'lang':
                    this.filterLang(kwd, row);
                    break;    
            }
        }
    },
    watch: {
        'pushDeviceFilterForm.os'(event) {
            if (event) {
                this.getPlatformConfig(event).then(res => {
                    this.platformConfig = res.result;
                });
            }
        },
        data: {
            handler() {
                this.pushDeviceFilterForm = Object.keys(this.data.conditions).length ? this.$lodash.cloneDeep(this.data.conditions) : this.pushDeviceFilterForm;
                const keys = Object.keys(this.pushDeviceFilterForm);
                for (let key in this.pushDeviceFilterForm) {
                    if (typeof this.pushDeviceFilterForm[key] === 'string' && key !== 'os') {
                        this.pushDeviceFilterForm[key] = this.pushDeviceFilterForm[key].split(',');
                        if (['reg_date', 'last_login_date'].includes(key)) {
                            this.pushDeviceFilterForm[key] = this.pushDeviceFilterForm[key].map(item => item || undefined);
                        }
                    }
                }
                this.userPositionFormItems.forEach(item => {
                    if (keys.indexOf(item.key) > -1) {
                        item.checked = true;
                        this.groupOptions.forEach(keys => {
                            if (keys.label === item.label) {
                                keys.checked = true;
                            }
                        });
                    }
                });
            },
            deep: true 
        },
        platformConfig: {
            handler(val) {
                this.userPositionFormItems.forEach(item => {
                    if (item.key === 'package_id') {
                        item.options = val.package_list.map(list => {
                            return {
                                label: list.package_name,
                                value: list.package_id
                            };
                        });
                    }
                    if (item.key === 'game_version_id') {
                        item.options = val.gameversion_list.map(list => {
                            return {
                                label: list.game_version,
                                value: list.game_version_id
                            };
                        });
                    }
                    if (item.key === 'sdk_version_id') {
                        item.options = val.sdkversion_list.map(list => {
                            return {
                                label: list.sdk_version,
                                value: list.sdk_version_id
                            };
                        });
                    }
                    if (item.key === 'country') {
                        item.options = val.country_list.map(list => {
                            return {
                                label: list.name_cn,
                                value: list.name
                            };
                        });
                    }
                    if (item.key === 'lang') {
                        item.options = this.$activeGameInfo.lang.map(list => {
                            return {
                                label: list.name,
                                value: list.full_code
                            };
                        });
                    }
                });
            },
            deep: true
        }
    }
};
</script>
<style lang="scss" scoped>
.push-scheme-container{
    position: relative;
    .border-form-item{
        .flex{
            
            display: inline-flex;
            align-items: center;
            span{
                margin: 0 10px;
            }
        }
        .slider{ 
            line-height: 20px;
            vertical-align: top;
            margin-bottom: 14px;
        }
    }
    .device-flex{
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        .device-number{
            color: #409EFF;
            font-size: 16px;
            span{
                color: #606266;
                font-size: 12px;
            }
        }
    }
   
}
    
</style>



// WEBPACK FOOTER //
// website/subComponents/push/PushDeviceFilter.vue